<div class="fixed bottom-10 right-6 z-[300] flex flex-col gap-4 max-w-sm w-full">
    <div 
        *ngFor="let toast of toasts$ | async"
        class="group relative flex items-start gap-4 p-5 bg-white border rounded-sm shadow-2xl animate-toast-in overflow-hidden"
        [ngClass]="{
            'border-[#C9A227] bg-[#FFFFFF]': toast.type === 'success',
            'border-red-200 bg-[#FFF5F5]': toast.type === 'error',
            'border-[#2C4A3B] bg-[#FFFFFF]': toast.type === 'info'
        }"
    >
        <!-- Background Decoration -->
        <div class="absolute -bottom-2 -right-2 opacity-5 pointer-events-none transform rotate-12 transition-transform group-hover:scale-110">
            <span class="text-6xl" *ngIf="toast.type === 'success'">🌿</span>
            <span class="text-6xl" *ngIf="toast.type === 'error'">🍂</span>
            <span class="text-6xl" *ngIf="toast.type === 'info'">🍃</span>
        </div>

        <!-- Progress Bar (Visual only) -->
        <div 
            class="absolute bottom-0 left-0 h-0.5 transition-all duration-[3000ms] linear w-full"
            [ngClass]="{
                'bg-[#C9A227]': toast.type === 'success',
                'bg-red-500': toast.type === 'error',
                'bg-[#2C4A3B]': toast.type === 'info'
            }"
        ></div>

        <!-- Icon -->
        <div class="shrink-0 mt-0.5">
            <svg *ngIf="toast.type === 'success'" class="w-5 h-5 text-[#C9A227]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <svg *ngIf="toast.type === 'error'" class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <svg *ngIf="toast.type === 'info'" class="w-5 h-5 text-[#2C4A3B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
        </div>

        <!-- Content -->
        <div class="flex-1 min-w-0 pr-4">
            <h4 class="text-[10px] uppercase tracking-[0.2em] font-serif mb-1" [ngClass]="{
                'text-[#C9A227]': toast.type === 'success',
                'text-red-700': toast.type === 'error',
                'text-[#2C4A3B]': toast.type === 'info'
            }">
                {{ toast.type === 'success' ? 'Ritual Confirmed' : (toast.type === 'error' ? 'Veda Warning' : 'Aarvya Insight') }}
            </h4>
            <p class="text-sm font-serif text-[#1A2E22] leading-relaxed italic">
                "{{ toast.message }}"
            </p>
        </div>

        <!-- Close Button -->
        <button 
            (click)="remove(toast.id)"
            class="shrink-0 p-1 hover:bg-black/5 rounded-sm transition-colors"
        >
            <svg class="w-3 h-3 text-[#8B7355]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
    </div>
</div>
